import { render, staticRenderFns } from "./ListExpressEdit.vue?vue&type=template&id=b90c3580&scoped=true&"
import script from "./ListExpressEdit.vue?vue&type=script&lang=js&"
export * from "./ListExpressEdit.vue?vue&type=script&lang=js&"
import style0 from "./ListExpressEdit.vue?vue&type=style&index=0&id=b90c3580&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90c3580",
  null
  
)

export default component.exports